import React from "react";

import "./errorPage.css";

import errors from "../data/json/errors.json";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../components/button";
import { useSafeNavigate } from "../components/unloadBlocker";

import ErrorGraphic from "../assets/img/error-graphic.png";

export default function ErrorPage() {

    const navigate = useSafeNavigate(useNavigate());
    const {id} = useParams();

    const error = id ? errors[id as keyof typeof errors] : undefined;

    return <div className="page error-page">
        <img src={ErrorGraphic} alt="Error" className="error-image"/>
        <div className="error-content">
            <h1 className="error-title">{error?.title || "Unknown Error"}</h1>
            <p className="error-message">{error?.message || "An unknown error occurred."}</p>
            <p className="error-suggestion quotation">Please try again later or contact support.</p>
            <Button onClick={() => {
                navigate("/")
            }}>Back to home</Button>
        </div>
    </div>

}